<template>
  <el-tabs v-model="activeName">
    <el-tab-pane label="停盘报警" name="risk1">
      <div class="block">
        <el-form>
          <el-form-item>
            <el-button type="danger" @click="dialogVisible=true">新增停盘报警</el-button>
          </el-form-item>
        </el-form>
        <el-dialog title="新增停盘报警" :visible.sync="dialogVisible" width="60%" @close="clearData">
          <el-form :model="tradingData" label-width="120px" :label-position="'right'">
            <el-form-item label="交易对">
              <el-input v-model="tradingData.symbol" placeholder="请输入交易对" required="required" clearable></el-input>
            </el-form-item>
            <el-form-item label="时间长度">
              <el-input v-model="tradingData.duration" placeholder="请输入时间长度，时间以分钟为单位" type="number" required="required" clearable></el-input>
            </el-form-item>
            <el-form-item label="级别">
              <el-select v-model="tradingData.level">
                <el-option v-for="item in levelList" :label="item.label" :value="item.value" :key="item.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="消息频率" >
              <el-input v-model="tradingData.messageFrequency" placeholder="请输入级别" type="number" required="required" clearable></el-input>
            </el-form-item>
            <!-- <el-form-item label="报警群" prop="level">
              <el-select v-model="tradingData.level">
                <el-option v-for="item in groupList" :label="item.label" :value="item.value" :key="item.label"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item  label="是否打电话">
              <el-radio-group v-model="tradingData.isCall">
                <el-radio class="radio" :label="true">是</el-radio>
                <el-radio class="radio" :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item  label="状态">
              <el-radio-group v-model="tradingData.enable">
                <el-radio class="radio" label="1">启动</el-radio>
                <el-radio class="radio" label="0">禁用</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="addTradingRisk">立即创建</el-button>
              <el-button @click="dialogVisible=false">取消</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>

        <el-form :inline="true">
          <el-form :inline="true">
            <el-form-item  label="交易对:">
              <el-autocomplete style="width: 50%;margin-right:5px" placeholder="输入搜索交易对" v-model="symbol"
                               :fetch-suggestions="querySymbol"  @change="buildSymbolInfo"/>
              <el-button type="primary" style="margin-right:5px" @click="buildSymbolInfo()">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-form>

        <el-form :model="symbolInfo" label-width="150px" ref="form">
          <el-form-item label="交易所" prop="exchanges">
            <el-input v-model="symbolInfo.exchanges"></el-input>
          </el-form-item>
          <el-form-item label="时间长度" prop="duration">
            <el-input-number v-model="symbolInfo.duration"></el-input-number>
          </el-form-item>
          <el-form-item label="级别" prop="level">
            <el-select v-model="symbolInfo.level">
              <el-option v-for="item in levelList" :label="item.label" :value="item.value" :key="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="消息频率" prop="messageFrequency">
            <el-input-number v-model="symbolInfo.messageFrequency"></el-input-number>
          </el-form-item>
          <!-- <el-form-item label="报警群" prop="level">
            <el-select v-model="symbolInfo.level">
              <el-option v-for="item in groupList" :label="item.label" :value="item.value" :key="item.label"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item  label="是否打电话" prop="isCall">
            <el-radio-group v-model="symbolInfo.isCall">
              <el-radio class="radio" :label="true">是</el-radio>
              <el-radio class="radio" :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item  label="状态" prop="enable">
            <el-radio-group v-model="symbolInfo.enable">
              <el-radio class="radio" :label="1">启动</el-radio>
              <el-radio class="radio" :label="0">禁止</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="updateTradingRisk()">确认修改</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-tab-pane>
    <el-tab-pane label="盘口价差报警" name="risk2">
      <handicap-price-spread-controller></handicap-price-spread-controller>
    </el-tab-pane>
    <el-tab-pane label="价格报警" name="risk3">
      <price-controller></price-controller>
    </el-tab-pane>
    <el-tab-pane label="搬砖报警" name="risk4">
      <BrickController></BrickController>
    </el-tab-pane>
    <el-tab-pane label="深度不足报警" name="risk5">
      <depth-controller></depth-controller>
    </el-tab-pane>
    <el-tab-pane label="资产报警" name="risk6">
      <assets-controller></assets-controller>
    </el-tab-pane>
    <el-tab-pane label="需对冲量报警" name="risk7">
      <impulse-controller></impulse-controller>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import utils from './utils'
import PriceController from "@/entries/RiskController/PriceController"
import BrickController from "@/entries/RiskController/BrickController"
import DepthController from "@/entries/RiskController/DepthController"
import HandicapPriceSpreadController from "@/entries/RiskController/HandicapPriceSpreadController";
import AssetsController from "@/entries/RiskController/AssetsController";
import ImpulseController from "@/entries/RiskController/ImpulseController"

const exchangeOptions = [
  "BINANCE", "HUOBI",  "OKEX", "MXC"
]

export default {
  components: {
    PriceController:PriceController,
    BrickController:BrickController,
    DepthController:DepthController,
    HandicapPriceSpreadController: HandicapPriceSpreadController,
    AssetsController:AssetsController,
    ImpulseController:ImpulseController
  },
  comments:{
    'BrickController':BrickController,
    'PriceController':PriceController,
    'DepthController':DepthController,
    'HandicapPriceSpreadController':HandicapPriceSpreadController,
    'AssetsController':AssetsController,
    'ImpulseController':ImpulseController
  },

  name: "RiskController",
  data(){
    return{
      symbol:'',
      activeName:'risk1',
      brushPair:'',
      tableData:[],
      formInfo:{},
      tradingData:{
        id:0,
        symbol:'',
        exchanges:'',
        duration:'',
        level:'',
        enable:'',
        messageFrequency:'',
        isCall:''
      },
      restaurants: [],
      exchangeEnum:exchangeOptions,
      dialogVisible: false,
      symbolInfo:{},
      symbolList: [],
      levelList: [{label:'主区',value:1},{label:'其他',value:2},{label:'项目方',value:3}],
      groupList: [{label: 'group_cex', value: 'group_cex'},{label: 'group_dex', value: 'group_dex'},{label: 'group_dex1', value: 'group_dex1'}]
    }
  },
  computed: {

  },
  methods: {
    setThreshold(data, name, value) {
      if (name === 'duration'){
        if(value < 0){this.$message.warning("警告：时间长度不小于0")}
        return
      }
      data[name] = value
    },
    // rightsContains(r) {
    //   console.log("@@@@@@@@@@@@@@@@@@@@@@: " + this.userRights)
    //   let rights = this.userRights.split(",") || [];
    //   return rights.indexOf(RIGHTS_TYPE[r]) !== -1;
    // },
    filterRecords(){

    },
    clearData(){
      this.tradingData = {
        id:0,
        symbol:'',
        exchanges:'',
        duration:'',
        level:'',
        enable:'',
        messageFrequency:'',
        isCall:''
      }
    },
    addTradingRisk(){
      utils.addOrUpdateStopTradingAlarm(this.tradingData).then((response)=>{
        if (response.code == 0){
          this.$message.success("添加成功")
          this.queryStopTradingAlarm();
        }else {
          this.$message.error("添加失败")
        }
      })
    },
    updateTradingRisk(){
      utils.addOrUpdateStopTradingAlarm(this.symbolInfo).then((response)=>{
        if (response.code == 0){
          this.$message.success("更新成功")
          this.queryStopTradingAlarm();
        }else {
          this.$message.error("更新失败")
        }
      })
    },
    queryStopTradingAlarm(){
      utils.queryStopTradingAlarm().then((response)=>{
        this.symbolList = response.data;
      })
    },
    querySymbol(queryString,cb) {
      let restaurants = this.symbolList;
      let results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      let suggest = [];
      for(let index in results) {
        suggest.push({'value':results[index].symbol});
      }
      cb(suggest);

    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.symbol.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },

    buildSymbolInfo(){
      this.symbolInfo = {};
      for (let i in this.symbolList) {
        if (this.symbol === this.symbolList[i].symbol) {
          this.symbolInfo = JSON.parse(JSON.stringify(this.symbolList[i]));
          return;
        }
      }
    },
  },
  mounted() {
    // this.queryStopTradingAlarm()
  },

  created(){
    this.queryStopTradingAlarm();
  }
}
</script>

<style scoped>
.block{
  background-color: white;
  margin: 20px 0 20px 0;
  padding: 20px 20px 20px 20px;
}
</style>
